import { Button, Flex, Heading, Link, Text } from '@grammarly/design-system'
import { DocumentSparkles } from '../icons/DocumentSparkles'
import classes from './UserSignIn.module.scss'

const capabilities = [
  {
    title: 'Draft replies to emails',
  },
  {
    title: 'Summarize long docs',
  },
  {
    title: 'Offer feedback on your writing',
  },
]

type Props = {
  onSignIn: () => void
  onSignUp: () => void
}

/**
 * Logged out view to display when the user is not logged in.
 */
export function UserSignIn({ onSignIn, onSignUp }: Props) {
  return (
    <Flex justify="center" height="100%">
      <Flex
        padding={6}
        gap={8}
        flex="1"
        align="center"
        justify="center"
        direction="column"
        style={{ maxWidth: 360 }}
      >
        <DocumentSparkles accessibilityLabel="" />
        <Flex direction="column" align="center">
          <Heading as="h1" variant="heading-small">
            Sign in to chat with AI
          </Heading>
          <Text as="p" variant="text-small" color="base-subdued">
            Get help with what you're reading or writing.
          </Text>
          <Text as="p" variant="text-small" color="base-subdued">
            Sign in so our AI can:
          </Text>
          <ul className={classes.capabilities}>
            {capabilities.map(capability => (
              <li key={capability.title}>
                <Text as="span" color="base-subdued" variant="text-small">
                  {capability.title}
                </Text>
              </li>
            ))}
          </ul>
        </Flex>

        <Flex direction="column" gap={4} align="center" width="100%">
          <Button
            variant="primary"
            size="large"
            width="full"
            onClick={onSignIn}
            accessibilityLabel="Sign in to Grammarly"
          >
            Sign in
          </Button>
          <Flex direction="column" align="center">
            <Text as="p" variant="text-small" color="base-subdued">
              Don't have an account?
            </Text>
            <Link
              onClick={e => {
                e.preventDefault()
                onSignUp()
              }}
              accessibilityLabel="Sign up for Grammarly"
              href=""
              variant="secondary"
            >
              <Text as="span" variant="text-small" color="base-subdued">
                Sign up
              </Text>
            </Link>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
